import { airBookingApi } from "@b2bportal/air-booking-api";
import { axiosInstance, trackEvent } from "@hopper-b2b/api";
import {
  type DenyScheduleChangeRequest,
  type DenyScheduleChangeResponse,
  NETWORK_CALL_FAILED,
} from "@hopper-b2b/types";

export const denyScheduleChange = async (
  req: DenyScheduleChangeRequest
): Promise<DenyScheduleChangeResponse> => {
  const res = await airBookingApi(axiosInstance)
    .apiV0ItineraryFlightDenyScheduleChangePost(req)
    .catch((e) => {
      trackEvent({
        eventName: NETWORK_CALL_FAILED,
        properties: {
          url: window.location.pathname,
        },
      });
      throw e;
    });

  if (!res.data.success) {
    throw res.data;
  }

  return res.data;
};
